import { TableCell, TableHead, TableRow, TextField } from '@mui/material';
import React from 'react';

const getColumnSx = (column, compact) => ({
  fontWeight: 600,
  ...(column.width && { width: column.width }),
  ...(column.maxWidth && { maxWidth: column.maxWidth }),
  ...(compact && { fontSize: '0.8125rem', py: 0.75, px: 1 }),
});

export function TableHeadComponent({
  tableCells,
  showFilter = false,
  filters = {},
  onFilterChange = () => {},
  compact = false,
}) {
  return (
    <TableHead>
      {showFilter ? (
        <>
          <TableRow>
            {tableCells &&
              tableCells.length > 0 &&
              tableCells.map((t, index) => (
                <TableCell key={'filter-' + index + t.id}>
                  {t.filterable ? (
                    <TextField
                      variant='standard'
                      placeholder={`Filter ${t.title}`}
                      value={filters[t.id] || ''}
                      onChange={(e) => onFilterChange(t.id, e.target.value)}
                      fullWidth
                    />
                  ) : (
                    <>{t.title}</>
                  )}
                </TableCell>
              ))}
          </TableRow>
        </>
      ) : (
        <>
          <TableRow>
            {tableCells &&
              Object.keys(tableCells).length > 0 &&
              tableCells.map((t, index) => (
                <TableCell
                  key={index + t.id}
                  align='left'
                  sx={{
                    fontFamily: "'Jameel Noori Nastaleeq', serif",
                    whiteSpace: 'nowrap',
                    ...getColumnSx(t, compact),
                  }}
                >
                  {t.title}
                </TableCell>
              ))}
          </TableRow>
        </>
      )}
    </TableHead>
  );
}
